import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from './services/authentication.service';
import {LocalStorageService} from 'angular-2-local-storage';
import {StorageItem} from './enums/storage-item';
import {environment} from '../environments/environment';
import {ActivatedRoute, Route, Router} from "@angular/router";
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  title = 'merak-customer-ui';
  doNotTranslate = ['emailConfirmation', 'cancelRequest'];

  constructor(
    private eauthenticationService: AuthenticationService,
    private localStorage: LocalStorageService,
    private route: Router,
    private titleService: Title
  ) {}

  ngOnInit() {
    this.setRobotsMetaTag();
    let profile: any = this.localStorage.get(StorageItem.PROFILE);
    if (!profile?.locale) {
      profile = {
        locale: navigator.language.substring(0, 2)
      };
      this.localStorage.set(StorageItem.PROFILE, profile);
    }
    if (environment.production && window.location.pathname.substring(1, 3) !== profile.locale.substring(0, 2) && this.translateValidation()) {
      window.location.replace(`${window.location.protocol}//${window.location.host}/${profile.locale.substring(0, 2)}/${window.location.pathname.substring(4)}${window.location.search}`);
    }
    this.titleService.setTitle(environment.title);
  }
  translateValidation(){
    let translate = true;
    this.doNotTranslate.forEach(
      it => {
        if (window.location.pathname.search(it)){
          translate = false;
        }
      }
    );
    return translate;
  }

  setRobotsMetaTag() {
    const robotsMeta = document.querySelector('meta[name="robots"]');
    if (robotsMeta) {
      robotsMeta.setAttribute(
        'content',
        environment.allowIndexing ? 'index, follow' : 'noindex, nofollow'
      );
    }
  }
}




